import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/system/Box';
import Paper from '@mui/material/Paper';
import Form from './LoginForm';
import { Alert, AlertTitle, DialogTitle, DialogActions, DialogContentText, Button, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { appTheme, appAccessibilityTheme } from '../AppTheme';
import { properties, device } from '../redux/Selectors.js';
import { createTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DEVICE_ACC } from '../common/navigationTools.js';

const ModalDialog = ({ open, handleClose, title }) => {
    const _properties = useSelector((state) => properties(state));
    const _device = useSelector((state) => device(state));
    const theme = createTheme(_device === DEVICE_ACC ? appAccessibilityTheme(_properties) : appTheme(_properties));
    return (
        // props received from App.js
        <ThemeProvider theme={theme}>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <Paper elevation={0}>
                        <Form handleClose={handleClose} />
                    </Paper>
                </DialogContent>
            </Dialog>
        </ThemeProvider>
    );
};

export default ModalDialog;

export const ConfirmationDialog = ({ okAction, cancelAction, msg, title, open, ...props }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} aria-modal="true" {...props}>
            <DialogTitle>{t(title)}</DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="alert-dialog-description"
                    dangerouslySetInnerHTML={{
                        __html: msg
                    }} />
                <DialogActions>
                    <Button onClick={okAction}>
                        {t('common.yes')}
                    </Button>
                    <Button autoFocus onClick={cancelAction}>
                        {t('common.no')}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

export const MessageBox = ({ open, handleClose, title, message, severity, messageText }) => {
    const { t } = useTranslation();

    const text = message ? t(message) : messageText;

    return (
        <Dialog open={open}>
            {title && (
                <DialogTitle>{t(title)}</DialogTitle>
            )}
            <Alert severity={severity} >
                {text}
            </Alert>
            <Button autoFocus onClick={handleClose}>
                {t('main.ok')}
            </Button>
        </Dialog>
    );
}
